import PropTypes from 'prop-types';
import React from 'react';
import S from 'modal.scss';
import Dropzone from 'react-dropzone';
import dropStyles from 'dropzoneStyles.scss';
import SimpleInput from 'components/SimpleInput';
import ColoredButton from 'components/ColoredButton';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { uploadDocument, updatePhase, removeFlagFromPhase, clearValidation } from 'actionCreators';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { connect } from 'react-redux';
import { Dialog } from 'react-toolbox';
import { getPhaseErrors, getDocumentUploadError } from '../../../../../reducers';
import FlagType from 'types/flag';
import { errorSummary } from '../../../../../utils';

import styles from 'styles/input.scss';

const DEFAULT_STATE = {
  yearBuilt: '',
  file: null,
  errors: {},
};

class VerifyBuildDateModal extends Resetter(Validator(React.Component)) {
  static VALIDATIONS = {
    yearBuilt: 'This field is required',
    file: 'A document is required',
  }

  static DEFAULT_STATE = DEFAULT_STATE;

  // Clear out any leftover phase validation errors (e.g. from a failed task
  // completion elsewhere on the page) so they don't bleed into this modal.
  componentWillReceiveProps = newProps => (newProps.active && !this.props.active ?
    this.props.clearValidation() : null);

  handleYearBuiltChange = e => this.setState({ yearBuilt: e.target.value });

  handleDrop = (files) => {
    const [file] = files;
    this.setState({ file });
  }

  handleRemoveFile = () => this.setState({ file: null });

  handleSubmit = () => {
    if (!this.validate()) return;

    const { flag } = this.props;
    const { yearBuilt, file } = this.state;
    const phaseID = flag.phase_id;

    const formData = new FormData();
    formData.append('document_upload[assets][][asset]', file);
    formData.append('document_upload[assets][][document_name]', 'Build Date Proof');
    formData.append('document_upload[assets][][document_type]', 'Misc');

    this.props.uploadDocument(formData, phaseID)
      .then(() => this.props.updatePhase({ id: phaseID, year_built: yearBuilt }, {}))
      .then(() => this.props.removeFlagFromPhase(phaseID, {
        id: flag.id,
        note: 'Year built verified',
      }))
      .then(() => this.handleClose())
      .catch(() => {}); // catching this to avoid console warnings...
  }

  handleClose() {
    this.props.clearValidation();
    super.handleClose();
  }

  handleCancel = () => this.handleClose();

  render() {
    const { yearBuilt, file, errors } = this.state;
    const { active, flag, phaseErrors, uploadError } = this.props;
    const flagName = flag ? flag.name : '';

    return (
      <Dialog
        active={active}
        className={S.modal}
        type="fullscreen"
        onEscKeyDown={this.handleClose}
        onOverlayClick={this.handleClose}
      >
        <div className={styles.errored}>
          {Object.keys(phaseErrors).length > 0 &&
            <span className={styles.error}>{errorSummary(phaseErrors)}</span>}
          {uploadError && uploadError.document_uploads &&
            <span className={styles.error}>{uploadError.document_uploads.join(', ')}</span>}
        </div>

        <IconButton
          icon="close"
          className={S.close}
          onClick={this.handleCancel}
          tabIndex={-1}
        />

        <h5 className={S.title}>{flagName}</h5>

        <SimpleInput
          label="Year Built *"
          text={yearBuilt}
          errors={errors.yearBuilt || []}
          onChange={this.handleYearBuiltChange}
        />

        <Dropzone className={dropStyles.uploadFile} onDrop={this.handleDrop}>
          <ColoredButton color="blue">
            {file ? 'Replace document' : 'Upload year built proof'}
          </ColoredButton>
        </Dropzone>
        {errors.file && <span className={styles.error}>{errors.file.join(', ')}</span>}
        {file && (
          <p>
            {file.name}
            <Button label="Remove" flat inverse ripple onClick={this.handleRemoveFile} />
          </p>
        )}

        <Button
          label="Submit"
          flat inverse ripple
          className={S.submit}
          onClick={this.handleSubmit}
        />
      </Dialog>
    );
  }
}

VerifyBuildDateModal.propTypes = {
  active: PropTypes.bool.isRequired,
  phaseErrors: PropTypes.object,
  uploadError: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  uploadDocument: PropTypes.func.isRequired,
  updatePhase: PropTypes.func.isRequired,
  removeFlagFromPhase: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  clearValidation: PropTypes.func.isRequired,
  flag: FlagType,
};

VerifyBuildDateModal.defaultProps = { active: false };

export default connect(
  state => ({
    phaseErrors: getPhaseErrors(state),
    uploadError: getDocumentUploadError(state),
  }),
  { uploadDocument, updatePhase, removeFlagFromPhase, clearValidation },
)(VerifyBuildDateModal);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/components/verifyBuildDateModal.jsx